import ErrorText from '@atoms/Typographies/Texts/ErrorText';
import React from 'react';
import { Form } from 'react-bootstrap';



type Props = {
    register: any,
    controlId: string,
    data: any,
    error?: any,
}


const Radio = (props: Props) => {
    const { controlId, register, error, data } = props;

    return (
        <Form.Group controlId={controlId}>
            {data.map((item: any) => (
                <span key={`${controlId}-${item.value}`}>
                    <Form.Check
                        inline
                        type='radio'
                        label={item.label}
                        value={item.value}
                        id={`${controlId}-${item.value}`}
                        {...register(controlId)}
                    />
                </span>
            ))}
            {error && <ErrorText>{error.message}</ErrorText>}
        </Form.Group>
    )
}


export default Radio;